import { Params } from '@angular/router';

export function FindAllGetParameters(): Params {
  const queryParams: Params = {};

  location.search
    .substring(1)
    .split('&')
    .forEach((p) => {
      const tmp = p.split('=');
      queryParams[tmp[0]] = tmp[1];
    });

  return queryParams;
}
